module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Hi Hat Foot-d802539cee98f678cd01de56663142d3.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Hi Hat Foot.mp3
// module id = 49
// module chunks = 0